import { getDocs} from "firebase/firestore";
import { db } from "../../config/InitFirebase"; // Assurez-vous que le chemin est correct
import { collection, onSnapshot } from "firebase/firestore";

const musicEventsCollectionRef = collection(db, "musicEvents");
 
//se code faire une requête à firestore à chaque fois 
export const getMusicEventsList = async () => {
    try {
        const data = await getDocs(musicEventsCollectionRef);
        const filteredData = data.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
        }));
        return filteredData;
    } catch (err) {
        console.error(err);
        throw err;
    }
};

//-------------------------------GET Event music-------------------------------
//écouter la mise à jour en temps réel et éviter de requêter à chaque fois la base de données firestore. 
//Cela permettra d'éviter d'avoir trop de requête et dépasser les quotas firestore
//onSnapshot écoute les mises à jour en temps réel 
//stocke dans le cache les infos et les change que quand il y a un changement dans firestore. On arrête de requêter à chaque fois la page
export const listenToMusicEventList = (callback) => {
    return onSnapshot(musicEventsCollectionRef, (snapshot) => {
        const musicEventList = snapshot.docs.map((doc) => {
            const data = doc.data();
            console.log('event.dateStart:', data.dateStart); // Vérifie le contenu de dateStart
            return {
            ...data,
            id: doc.id,
            dateStart: data.dateStart?.toDate?.() ?? null,
            dateEnd: data.dateEnd?.toDate?.() ?? null,
            };
        });
        callback(musicEventList);
    });
};